export default function NTAutomationSection() {
  return (
    <>
      <section className="relative w-full h-[380px] md:h-[440px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=large%20industrial%20factory%20interior%20wide%20shot%20automated%20machinery%20production%20line%20workers%20modern%20manufacturing%20plant%20professional%20bright&width=1400&height=500&seq=ntauto1&orientation=landscape"
          alt="Automação Industrial"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-[#1B1F5E]/80"></div>
        <div className="absolute inset-0 flex items-center">
          <div className="max-w-7xl mx-auto px-6 w-full">
            <h2 className="font-rajdhani font-bold text-white text-4xl md:text-5xl mb-3">Automação Industrial</h2>
            <p className="text-white/90 text-lg md:text-xl font-light">
              Conhecimento para entender.<br />
              Experiência para surpreender.
            </p>
          </div>
        </div>
      </section>

    </>
  );
}
